export enum LiveStreamingClientMethodNames {
    DeviceLiveStreamChanged = "DeviceLiveStreamChanged",
}

export const liveStreamingGroupId = "livestreaming";
export const liveStreamingClientMethodNames = [
    LiveStreamingClientMethodNames.DeviceLiveStreamChanged,
];
